<template>
  <div class="proceso-colores-form p-3 mb-2 bg-gray-50 rounded border border-gray-200">
    <el-row
      :gutter="10"
      align="bottom"
    >
      <custom-input-number
        v-if="config.showFrente"
        v-model="model.CantidadColoresFrente"
        :spanColumn="2"
        :label="etiquetasProceso.CantidadColoresFrente || 'Colores Frente'"
        :settings="inputSettings"
      />

      <custom-input-number
        v-if="config.showLiner"
        v-model="model.CantidadColoresLiner"
        :spanColumn="2"
        :label="etiquetasProceso.CantidadColoresLiner || 'Colores Liner'"
        :settings="inputSettings"
      />

      <custom-input-number
        v-if="config.showAdhesivo"
        v-model="model.CantidadColoresAdhesivo"
        :spanColumn="2"
        :label="etiquetasProceso.CantidadColoresAdhesivo || 'Colores Adhesivo'"
        :settings="inputSettings"
      />

      <custom-input-number
        v-if="config.showCambios"
        v-model="model.CantidadCambios"
        :spanColumn="2"
        :label="etiquetasProceso.CantidadCambios || 'Cambios'"
        :settings="inputSettings"
      />

      <el-col
        :span="2"
        class="text-right"
      >
        <el-button
          type="primary"
          size="default"
          :disabled="disableUpdate"
          title="Generar filas de items según cantidades"
          @click="handleUpdate"
        >
          Actualizar
        </el-button>
      </el-col>
    </el-row>

    <div
      v-if="errorRecurso"
      class="text-red-500 text-xs mt-1"
    >
      {{ errorRecurso }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
// INYECCIONES

const props = defineProps({
  modelValue: { type: Object, required: true },
  proceso: { type: Object, required: true },
  recurso: { type: Object, default: null },
});

const etiquetasProceso = computed(() => {
  const p = props.proceso || {};

  const etiquetas = p.ProcesosEtiquetas;
  if (Array.isArray(etiquetas) && etiquetas.length > 0) {
    return etiquetas[0];
  }
  return etiquetas || {};
});
const emit = defineEmits(['update:modelValue', 'trigger-update-materials']);

const model = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const inputSettings = {
  min: 0,
  precision: 0,
  step: 1,
  controls: false,
  controlsPosition: 'right',
};

const config = computed(() => {
  const p = props.proceso || {};

  return {
    showFrente: !!p.CantidadColoresFrente,

    showLiner: !!p.CantidadColoresLiner,

    showAdhesivo: !!p.CantidadColoresAdhesivo,

    showCambios: !!p.CantidadCambios,
  };
});

const totalColoresIngresados = computed(() => {
  return (
    (model.value.CantidadColoresFrente || 0) +
    (model.value.CantidadColoresLiner || 0) +
    (model.value.CantidadColoresAdhesivo || 0)
  );
});

const errorRecurso = computed(() => {
  if (!props.recurso) {
    return null;
  }

  const maxColores = Number(props.recurso.Colores);
  const total = totalColoresIngresados.value;

  if (isNaN(maxColores) || props.recurso.Colores === null) {
    console.log('Validación: El recurso no tiene límite de colores definido (es null).');
    return null;
  }

  if (total > maxColores) {
    console.warn('!!! VALIDACIÓN FALLIDA: Supera límite !!!');
    return `La cantidad de colores (${total}) supera el máximo del recurso (${maxColores})`;
  }

  return null;
});

const disableUpdate = computed(() => !!errorRecurso.value);

const handleUpdate = () => {
  if (!disableUpdate.value) {
    emit('trigger-update-materials');
  } else {
    console.warn('Actualización deshabilitada por validación de recursos');
  }
};
</script>

<style scoped>
.proceso-colores-form {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
